<template>
    <div class="Service">
        <div class="pageContent">
            <TopLogoBar logoColor="black" logoSpecial="service" textColor="#000" title="Service" />
            <div class="container infoContainer">
                <div class="columns">
                    <div class="column is-6 is-offset-1 textContainer">
                        <p class="descriptionText">
                            page93® sviluppa e assiste le migliori soluzioni informatiche 
                            per l’efficienza aziendale; interviene con efficienza e rapidità 
                            per risolvere i problemi; propone il sistema per il controllo 
                            attivo e passivo chiavi in mano.<br><br>

                            Il servizio di assistenza costituisce la <i>core competence</i> di 
                            page93® e consente di accompagnare e guidare il cliente 
                            durante tutto il processo di implementazione del sistema.
                            <br><br>

                            I servizi offerti da page93® sono studiati per rispondere 
                            alle esigenze di diversi settori e per dare una risposta 
                            vincente alle problematiche delle aziende, dalla produzione al retail.
                            <br><br>

                           <!-- CLOUD TECHNOLOGY<br>
                            Attraverso la Cloud Technology di page93® la tua azienda
                            sarà in grado di adeguarsi all’andamento del business e
                            della domanda, seguendo l’organizzazione ovunque nel
                            mondo. I servizi IT basati sul Cloud consentono agli utenti di
                            accedere ai propri dati, dovunque essi si trovino, attraverso
                            una connessione internet.<br><br>
                            SICURMAIL<br>
                            Con i servizi page93® puoi portare la tua scrivania ovunque:
                            appuntamenti, attività, rubrica e posta elettronica ocunque
                            e sempre con te. Con SICURMAIL l’utente può utilizzare la
                            posta elettronica su più dispositivi contemporaneamente, così
                            da avere tutte le e-mail sempre replicate e disponibili online.<br><br>-->
                            SOLUZIONI MICROSOFT<br>
                            page93® offre tutte le soluzioni Microsoft sia per client che
                            per Server. Per quest’ultimo, in particolare, sono disponibili
                            tutte le soluzioni di rete quali: File Server, Terminal Server,
                            Mail Server Exchange, Server Backup, etc..
                        </p>
                    </div>
                    <div class="column is-4 imageContainer">
                        <img src="@/assets/images/services2.jpg" />
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
    import Footer from '@/components/Footer'
    import TopLogoBar from '@/components/TopLogoBar'
    export default {
        name: 'Service',
        props: [],
        components: {
            TopLogoBar,
            Footer
        },
    }
</script>

<style scoped lang="scss">
    .Service {
        width: 100%;

        .pageContent {
            width: 100%;
            position: relative;
            color: #000;

            .infoContainer {
                display: flex;
                // height: 100%;
                padding: 20px;
            }

            .textContainer {


                @media only screen and (min-width: 768px) {
                    margin-right: 50px;
                    margin-top: 60px;

                    max-height: 600px;
                    overflow: auto;
                    direction: rtl;
                }
            }

            .descriptionText {
                font-size: 1.1rem;
                font-weight: 900;
                text-align: left;
                text-align: justify;
                direction: ltr;

                @media only screen and (min-width: 768px) {
                    padding-left: 50px;
                }
            }

            .imageContainer {
                @media only screen and (min-width: 768px) {
                    margin-top: 60px;
                }

                img {

                    height: 100%;
                    width: 100%;
                    object-fit: contain;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

            }
        }
    }
</style>